import request from '../utils/request';

export function payList(param) {
    return request({
        url: '/admin/search-pay',
        method: 'get',
        params: param
    })
}

export function payListAll(param) {
    return request({
        url: '/admin/pay-all',
        method: 'get',
        params: param
    })
}

export function get_refund_list(param) {
    return request({
        url: "/admin/search-refund-apply",
        method: 'get',
        params: param
    })
}

export function payRefundAll(param) {
    return request({
        url: '/admin/refund-apply-all',
        method: 'get',
        params: param
    })
}

export function handleRefund(id, result) {
    return request({
        url: '/admin/apply-refund/'+id+'/refund/'+result,
        method: 'PUT',
    })
}

export function getRefundApplyStatusName() {
    return request({
        url: "/admin/apply-refund-status-name",
        method: 'get',
    })
}

export function getDetail(id) {
    return request({
        url: '/admin/order/'+id+'/info',
        method: 'get',
    })
}

export function editRefundMoney(data) {
    return request({
        url: '/admin/setRefundApplyAmount',
        method: 'put',
        data
    })
}

export function orderPayType() {
    return request({
        url: '/admin/orderPayType',
        method: 'get',
    })
}